export const GOOGLE_API_KEY = 'AIzaSyBxQLyXNJxhlZdbvVt-sjlB03BmDEi-40c';
